import React, { useEffect, useMemo, FC, useState } from "react";
import { Link } from "react-router-dom";

import { Col, Row } from "reactstrap";
import DataTable from "../../shared/base-components/DataTable";
import {
  useDeviceBuySellListMutation,
  useDevicePartBuySellListMutation,
} from "./BuySell.actions";
import BuySellDeviceList from "./BuySellDeviceList";
import BuySellDevicePartList from "./BuySellDevicePartList";

interface BuySellListProps {
  setSelectedCategory: React.Dispatch<React.SetStateAction<number>>;
  selectedCategory: number;
}

const BuySellList: FC<BuySellListProps> = ({
  selectedCategory,
  setSelectedCategory,
}) => {
  const {
    data: buySellDeviceListData,
    mutate: buySellDeviceListMutation,
    isLoading: isBuySellDeviceListLoading,
  } = useDeviceBuySellListMutation();
  const {
    data: devicePartListData,
    mutate: devicePartListMutation,
    isLoading: isDevicePartListLoading,
  } = useDevicePartBuySellListMutation();

  const [selectedFilter, setSelectedFilter] = useState<any>(0);

  useEffect(() => {
    if (selectedCategory === 1) buySellDeviceListMutation(selectedFilter);
    if (selectedCategory === 2) devicePartListMutation(selectedFilter);
  }, [selectedCategory, selectedFilter]);

  const categories = [
    { category: "Cihazlar", id: 1 },
    { category: "Malzemeler", id: 2 },
  ];

  const columns = useMemo(
    () => [
      {
        Header: "Kategoriler",
        filterable: false,
        disableFilters: true,
        accessor: "category",
        Cell: (user: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              <Link
                onClick={() => setSelectedCategory(user.row.original.id)}
                to="#"
                className="text-dark"
              >
                {user.row.original.category}
              </Link>
            </h5>
          </>
        ),
      },
      {
        Header: "İşlemler",
        Cell: (cellProps: any) => {
          return (
            <div className="d-flex gap-3">
              <Link
                onClick={() => setSelectedCategory(cellProps.row.original.id)}
                className="text-success"
                to="#"
              >
                <span className="mdi mdi-arrow-right-drop-circle text-success float-end font-size-15">
                  Detay
                </span>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <Row className="align-items-center"></Row>

      <Row>
        <Col lg="12">
          {selectedCategory === 0 && (
            <DataTable
              columns={columns}
              data={categories}
              isGlobalFilter={false}
              customPageSize={10}
              className="table align-middle datatable dt-responsive table-check nowrap"
            />
          )}

          {selectedCategory === 1 && (
            <BuySellDeviceList
              buySellDeviceListData={buySellDeviceListData}
              buySellDeviceListMutation={buySellDeviceListMutation}
              isBuySellDeviceListLoading={isBuySellDeviceListLoading}
              setSelectedFilter={setSelectedFilter}
            />
          )}

          {selectedCategory === 2 && (
            <BuySellDevicePartList
              buySellDevicePartListData={devicePartListData}
              buySellDevicePartListMutation={devicePartListMutation}
              isBuySellDevicePartListLoading={isDevicePartListLoading}
              setSelectedFilter={setSelectedFilter}
            />
          )}
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BuySellList;
